import { render, staticRenderFns } from "./VuesticTag.vue?vue&type=template&id=d43ab0b2&"
import script from "./VuesticTag.vue?vue&type=script&lang=js&"
export * from "./VuesticTag.vue?vue&type=script&lang=js&"
import style0 from "./VuesticTag.vue?vue&type=style&index=0&id=d43ab0b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports